import { Tooltip } from "@mui/material";
import { toast } from 'react-toastify';
import {log} from "../../Helper";
import {pickupFactoryOrdersURL} from "../utility/constants";
import { getAccessToken } from "../../utils/okta-config";
import { API_ROOT, REST_URL } from "../../constants/constants";
import { CustomToolTipCMR, CustomToolTipDownload } from "../../avis/orders/utility/tooltip";
import { documentsToDownloadCMR,documentsToDownload } from "../../utils/utils";

export async function ordersData(isInternal, supplierNo, pageSize, pageNumber) {

    try {
        let url = pickupFactoryOrdersURL + `/` + pageNumber + `/` + pageSize;

        const requestOptions = {
          method: "GET",
          headers: {
            isInternal: isInternal,
            "supplierNo": supplierNo,
            // supplierNo: "317147", 
            Authorization: `Bearer ${getAccessToken()}`,
            "Access-Control-Allow-Origin": API_ROOT,
            "Content-Type": "application/json",
          },
        };
        const response = await fetch(url, requestOptions);
        if (!response.ok) {
            throw new Error(`Error! status: ${response.status}`);
        }
        const result = await response.json();

        const tableData = result.content.map((order) => {
            if (result) {
                for (let i = 0; i < order.links.length; i++) {

                    if (order.links.length > 0) {
                        if (order.links[0].rel) {
                          const cmrLinks = order.links.filter(
                            (link) => link.rel.includes("CMR")
                          );
                          const otherDocLink = order.links.filter(
                            (link) => !link.rel.includes("CMR")
                          );
                          // let link = order.links;
                          order.links = (
                            <span className="flex items-center">
                              <a onClick={() => documentsToDownload(otherDocLink)}>
                                <CustomToolTipDownload title="Download"/>
                              </a>
                              {cmrLinks.length > 0 ? (
                                <a onClick={() => documentsToDownloadCMR(cmrLinks)}>
                                  <CustomToolTipCMR title="Download CMR" />
                                </a>
                              ) : null}
                            </span>
                          );
                        }
                      }
                //     order.links = (
                //         <a onClick={() => documentsToDownload(link)}>
                // <span className="flex flex-col items-center">
                //   <Tooltip title="Download">
                //     <svg
                //         xmlns="http://www.w3.org/2000/svg"
                //         height="24"
                //         width="24"
                //         viewBox="0 0 50 50"
                //     >
                //       <path
                //           d="M11 40q-1.2 0-2.1-.9Q8 38.2 8 37v-7.15h3V37h26v-7.15h3V37q0 1.2-.9 2.1-.9.9-2.1.9Zm13-7.65-9.65-9.65 2.15-2.15 6 6V8h3v18.55l6-6 2.15 2.15Z"/>
                //     </svg>
                //   </Tooltip>
                // </span>
                //         </a>
                //     );
                }

            }
            return order;
        });
        return tableData;
    } catch (error) {
        log("Error occured when fetching data: ", error);
    }
}
